import React from "react";

function Copyright() {
  return (
    <div className="copyright-section">
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        
        <p className="mb-0">
          Copyright © 2026 Beyond Cool Products and Services LLP || All rights reserved.
        </p>

        <p className="mb-0">
          Designed & Developed by Janrise
        </p>

      </div>
    </div>
  );
}

export default Copyright;